<template>
  <div ref="page" class="pwc-question-form" :style="cFormStyle">
    <pwc-container class="pwc-app-container">
      <div class="pwc-logo" :style="cThankslogoStyle">
        <img src="../../assets/logo.png">
      </div>
      <div v-if="!submited" class="pwc-form-title">
        <span>{{ questionformDescription.Title }}</span>
      </div>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div v-if="!submited" class="pwc-form-desc" v-html="questionformDescription.Description" />
      <v-form v-if="!submited" ref="form" class="pwc-form-data">
        <!-- self info -->
        <div v-if="cIsLastPage && questionType === 'Q1'" class="pwc-form-self">
          <v-text-field
            v-model="submitData.name"
            validate-on-blur
            label="姓名"
            :rules="[rules.required]"
          />
          <v-text-field
            v-model="submitData.school"
            validate-on-blur
            label="学校"
            :rules="[rules.required]"
          />
          <v-radio-group
            v-model="submitData.grade"
            validate-on-blur
            label="年级"
            :rules="[v=> v ? true:'请选择']"
          >
            <v-radio v-for="o in grades" :key="o" :label="o" :value="o" />
          </v-radio-group>
          <v-text-field
            v-model="submitData.major"
            validate-on-blur
            label="专业"
            :rules="[rules.required]"
          />
          <label
            style="display:block; line-height:26px; margin-top:32px; margin-bottom:12px;"
            class="v-label theme--light"
          >
            联系方式
            <span
              style="color:rgb(192, 57, 43)"
            >（请确保填写真实信息，以便于我方学习顾问联系您提供一对一职业规划咨询。如无法联系，则视为自动放弃机会。）</span>
          </label>
          <v-text-field
            v-model="submitData.email"
            validate-on-blur
            label="邮箱"
            :rules="[rules.required, rules.email]"
          />
        </div>
        <div v-if="cIsLastPage && questionType !== 'Q3'" class="pwc-form-self">
          <pwc-phone
            :phone.sync="submitData.verification.phoneNo"
            :code.sync="submitData.verification.contryCode"
            @update:phone="resetProfile"
            @update:code="resetProfile"
          />
        </div>
        <div v-if="cIsLastPage && questionType === 'Q1'" class="pwc-form-self">
          <v-text-field v-model="submitData.weChatAccount" label="微信号(选填)" />
        </div>
        <div v-if="cIsLastPage && isShowProfile && questionType !== 'Q3'" class="pwc-form-self">
          <v-text-field
            v-model="submitData.name"
            validate-on-blur
            label="姓名"
            :rules="[rules.required]"
          />
          <v-text-field
            v-model="submitData.school"
            validate-on-blur
            label="学校"
            :rules="[rules.required]"
          />
          <v-radio-group
            v-if="questionType !== 'Q5'"
            v-model="submitData.grade"
            validate-on-blur
            label="年级"
            :rules="[v=> v ? true:'请选择']"
          >
            <v-radio v-for="o in grades" :key="o" :label="o" :value="o" />
          </v-radio-group>
          <v-text-field
            v-if="questionType !== 'Q5'"
            v-model="submitData.major"
            validate-on-blur
            label="专业"
            :rules="[rules.required]"
          />
          <v-text-field
            v-model="submitData.email"
            validate-on-blur
            label="邮箱"
            :rules="[rules.required, rules.email]"
          />
          <v-text-field v-if="questionType !== 'Q5'" v-model="submitData.weChatAccount" label="微信号(选填)" />
        </div>

        <!-- Q3 specitial -->
        <div v-if="cIsLastPage && questionType === 'Q3'" class="pwc-form-self">
          <v-text-field
            v-model="submitData.name"
            validate-on-blur
            label="您的姓名 *"
            :rules="[rules.required]"
          />
          <v-radio-group
            v-model="submitData.grade"
            validate-on-blur
            label="您目前就读几年级？*"
            :rules="[v=> v ? true:'请选择']"
          >
            <v-radio v-for="o in grades" :key="o" :label="o" :value="o" />
          </v-radio-group>
          <label
            style="display:block; line-height:26px; margin-top:32px; margin-bottom:12px;"
            class="v-label theme--light"
          >
            如果你对未来职业规划感到迷茫，需要获得专家指导，请留下你的联系电话。请务必填写正确并关注您的手机来电，后续我方顾问联系。
          </label>
          <pwc-phone
            :phone.sync="submitData.verification.phoneNo"
            :code.sync="submitData.verification.contryCode"
            @update:phone="resetProfile"
            @update:code="resetProfile"
          />
          <br>
          <v-text-field
            v-model="submitData.email"
            validate-on-blur
            label="（选填）填写邮箱，可获得普华永道 You Plus Anchor 提升营项目书完整版"
          />
        </div>
        <br>
        <!-- public question -->
        <component
          :is="p | getComponentName"
          v-for="(p,i) in questionformDescription[questionCurrentPage]"
          :key="i"
          v-model="questions[p.id]"
          :rules="p | getProperyRule"
          :label="p.label"
          solo
        >
          <template v-if="p.type === questionFormPropertyTypes.Radio">
            <v-radio
              v-for="o in p.options"
              :key="o.id"
              validate-on-blur
              :label="o.label"
              :value="o.id"
            />
          </template>
          <template v-if="p.type === questionFormPropertyTypes.Checkbox">
            <v-checkbox
              v-for="o in p.options"
              :key="o.id"
              v-model="questions[p.id]"
              multiple
              :label="o.label"
              :value="o.id"
            />
          </template>
        </component>

      </v-form>

      <v-layout v-if="!submited" row class="pwc-form-action" justify-space-around>
        <v-flex xs5>
          <v-btn color="#d04a02" depressed outline block @click="handleNext">{{ cButtonText }}</v-btn>
        </v-flex>
      </v-layout>
      <pwc-thanks-info v-if="submited" />
      <div v-if="!submited && cIsLastPage" class="pwc-form-privacy">
        <span>
          <a href="https://youplusapplication.businesstrainingshpwc.com/application/TermsOfUse.html">&nbsp;使用条款&nbsp;</a>和
          <a href="https://youplusapplication.businesstrainingshpwc.com/application/PrivacyStatement.html">&nbsp;隐私条款</a></span>
      </div>
    </pwc-container>

    <v-dialog v-if="showVerifyDialog" v-model="showVerifyDialog" max-width="320" persistent>
      <v-card>
        <v-form ref="verifyform" class="pwc-dialog-submit">
          <pwc-phone
            :phone.sync="submitData.verification.phoneNo"
            :code.sync="submitData.verification.contryCode"
          />
          <pwc-phone-verify
            :resendable="submitData.verification.phoneNo.length > 0"
            :verify-code="handleGetVerifyCode"
            :code.sync="submitData.verification.verificationCode"
          />
        </v-form>
        <v-card-actions>
          <v-spacer />
          <v-btn
            :disabled="loading.saveSurveyLoading"
            color="#d04a02"
            flat="flat"
            @click="handleVerifyDialogCancel"
          >取消</v-btn>
          <v-btn
            color="#d04a02"
            flat="flat"
            :loading="loading.saveSurveyLoading"
            @click="handleVerifyDialogConfirm"
          >确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { validRequired, validEmail } from '@/util/validation'
import PwcContainer from '@/views/layout/desktop/PwcContainer'
import { FormPropertyTypes, QuestionFromMap } from './forminfo'
import { VRadioGroup, VTextarea, VTextField } from 'vuetify/lib'
import PwcPhone from '@/components/PwcPhone/desktop'
import PwcPhoneVerify from '@/components/PwcPhoneVerify/desktop'
import PwcThanksInfo from './thanks'
import Actions from '@/constants/action'

import Detect from '@/util/detect'
const isMobile = Detect(window.navigator.userAgent).mobile()

const grades = [
  '大学一年级',
  '大学二年级',
  '大学三年级',
  '大学四年级',
  '研究生一年级',
  '研究生二年级',
  '研究生三年级'
]

export default {
  components: {
    PwcContainer,
    PwcPhone,
    PwcPhoneVerify,
    PwcThanksInfo,
    VRadioGroup,
    VTextarea,
    VTextField
  },
  filters: {
    getComponentName(p) {
      switch (p.type) {
        case FormPropertyTypes.Radio:
          return 'VRadioGroup'
        case FormPropertyTypes.Checkbox:
          return 'VRadioGroup'
        case FormPropertyTypes.Textarea:
          return 'VTextarea'
        case FormPropertyTypes.Textfield:
          return 'VTextField'
      }
    },
    getProperyRule(p) {
      const tipContent =
        p.type === FormPropertyTypes.Textarea ? '请输入' : '请选择'
      return p.required ? [v => !!v || tipContent] : [() => true]
    }
  },
  data() {
    return {
      questionType: this.$route.query.surveykey || 'Q1',
      questionformDescription: {},
      questionFormPropertyTypes: FormPropertyTypes,
      questionCurrentPage: 'P0',
      showVerifyDialog: false,
      rules: {
        required: validRequired,
        email: validEmail
      },
      questions: {},
      submited: false,
      submitData: {
        verification: {
          verificationCode: '',
          contryCode: 86,
          phoneNo: ''
        },

        // self info
        name: '',
        email: '',
        weChatAccount: '',
        school: '',
        grade: '',
        major: '',
        campaignCode: this.$route.query.code,
        surveyName: '',
        surveyKey: this.$route.query.surveykey,
        surveyInternalName: ''
      },

      grades,
      isShowProfile: false,
      isUserexist: true
    }
  },
  computed: {
    ...mapState(['loading']),
    cFormStyle() {
      if (isMobile) {
        return {
          'background-image': 'none'
        }
      }
      return {}
    },
    cThankslogoStyle() {
      if (!isMobile && this.submited) {
        return {
          'background-color': 'transparent'
        }
      }
      return {}
    },
    cButtonText() {
      return this.cIsLastPage ? '提交' : '下一步'
    },
    cIsLastPage() {
      const pages = Object.keys(this.questionformDescription).filter(
        v => v[0] === 'P'
      )
      if (pages.pop() === this.questionCurrentPage) {
        return true
      }
      return false
    }
  },
  created() {
    this.questionformDescription = QuestionFromMap[this.questionType]
  },
  methods: {
    ...mapActions({
      getVerifyCode: Actions.GET_VERIFY_CODE,
      saveSurvey: Actions.SAVE_SURVEY,
      checkUserExist: Actions.CHECK_USER_EXIST
    }),
    handleGetVerifyCode() {
      return this.getVerifyCode({
        contryCode: this.submitData.verification.contryCode,
        phoneNo: this.submitData.verification.phoneNo
      })
    },
    handleShowVerifyDialog() {
      this.showVerifyDialog = true
    },
    handleVerifyDialogCancel() {
      this.showVerifyDialog = false
    },
    handleVerifyDialogConfirm() {
      const validate = this.$refs.verifyform.validate()
      if (validate) {
        const questions = this.getFullQuestionList().map(v => {
          let answer = this.questions[v.id]
          if (typeof answer === 'string') {
            answer = [answer]
          }
          return {
            id: v.id,
            label: v.label,
            options: v.options,
            answers: answer
          }
        })

        const submitData = Object.assign({}, this.submitData, {
          questions: questions
        })
        submitData.surveyName = this.questionformDescription.Title
        submitData.surveyInternalName = this.questionformDescription.InternalTitle

        this.saveSurvey(submitData).then(() => {
          this.submited = true
          this.showVerifyDialog = false
        })
      }
    },
    handleNext() {
      const validate = this.$refs.form.validate()
      if (validate) {
        this.$refs.form.resetValidation()
        const pages = Object
          .keys(this.questionformDescription)
          .filter(v => v[0] === 'P')
        const currentIndex = pages.findIndex(v => v === this.questionCurrentPage)
        if (currentIndex !== -1 && pages.length - 1 > currentIndex) {
          this.questionCurrentPage = pages[currentIndex + 1]
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          })
        } else {
          this.handleShowVerifyDialog()
        }
      }
    },
    getFullQuestionList() {
      const full = []
      Object.keys(this.questionformDescription)
        .filter(v => v[0] === 'P')
        .forEach(v => {
          full.push(...this.questionformDescription[v])
        })

      return full
    },
    async resetProfile() {
      if (this.questionType !== 'Q1' && this.questionType !== 'Q3') {
        if (this.cIsLastPage && this.submitData.verification.phoneNo.length >= 7) {
          const res = await this.checkUserExist({
            contryCode: this.submitData.verification.contryCode,
            phoneNo: this.submitData.verification.phoneNo
          })
          this.isUserexist = res.data.isPhoneNoExist
        }

        if (this.isUserexist) {
          this.isShowProfile = false
          this.submitData.name = ''
          this.submitData.email = ''
          this.submitData.weChatAccount = ''
          this.submitData.school = ''
          this.submitData.grade = ''
          this.submitData.major = ''
        } else {
          this.isShowProfile = true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pwc-question-form {
  // height: 100vh;
  overflow-y: scroll;
  background-image: url("../../assets/register-form-bg.jpg");
  background-attachment: fixed;
  .pwc-app-container {
    margin-bottom: 0;
    margin-top: 0;
    padding-top: 36px;
    padding-bottom: 36px;
  }
  .pwc-form-title,
  .pwc-form-desc,
  .pwc-form-data,
  .pwc-form-action {
    margin: auto;
    max-width: 640px;
    padding-left: 20px;
    padding-right: 20px;
    background-color: #fff;
    padding-top: 24px;
  }
  .pwc-form-title {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    padding-top: 40px;
    padding-bottom: 20px;
  }
  .pwc-form-desc {
    text-align: left;
    font-size: 14px;
    font-weight: bold;
    line-height: 32px;
  }
  .pwc-form-action {
    text-align: center;
    padding-bottom: 32px;
  }
}
.pwc-logo {
  margin: auto;
  box-sizing: border-box;
  position: relative;
  height: auto;
  width: auto;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  max-width: 640px;
  padding-top: 36px;
  img {
    width: 400px;
  }
}
.pwc-dialog-submit {
  padding: 22px;
  padding-top: 36px;
  padding-bottom: 6px;
}

.pwc-form-privacy {
      text-align:center;
      font-size: 16px;
      padding-top: 30px;
      padding-bottom: 15px;
      background-color: #fff;
      max-width: 640px;
      margin: auto;
      height: auto;
      width: auto;
      overflow: hidden;
    }

@media all and (max-width: 960px){
  .pwc-logo {
  margin: auto;
  box-sizing: border-box;
  position: relative;
  height: auto;
  width: auto;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 300px;
  }
}
}
</style>

<style lang="scss">
.pwc-question-form {
  .theme--light.v-text-field.v-input--is-disabled
    > .v-input__control
    > .v-input__slot:before {
    border-image: none;
  }
  .v-text-field--box > .v-input__control > .v-input__slot {
    border-radius: 0;
  }
  .v-input--radio-group__input {
    .v-input--selection-controls {
      margin-top: 0;
    }
    .v-input__slot {
      margin-bottom: 4px;
    }
    .v-messages {
      display: none;
    }
  }
}
</style>
